import { Priority } from "@/constants/priority";
import type { Tag, TagWithRelationsCount } from "@/interfaces/tag";
import { httpClient } from "@/lib/api";

export type ListTagsResponse = {
  data: Tag[];
};

export type CreateTagPayload = {
  name: string;
  color: string;
};

export type ListTagsWithRelationsCountResponse = {
  data: TagWithRelationsCount[]
};

export class TagService {  
  public static async list() {
    const { data } = await httpClient().get<ListTagsResponse>(`/tag`);
    return data.data;
  }
  
  public static async listWithRelationsCount() {
    const { data } = await httpClient().get<ListTagsWithRelationsCountResponse>(`/tag/with-relations`);
    return data.data;
  }
  
  public static async create(payload: CreateTagPayload) {
    const { data } = await httpClient().post<Tag>(`/tag`, payload);
    return data;
  }

  public static async update(id: number, payload: CreateTagPayload) {
    const { data } = await httpClient().patch<Tag>(`/tag/${id}`, payload);
    return data;
  }

  public static async delete(id: number) {
    const { data } = await httpClient().delete(`/tag/${id}`);
    return data;
  }

  public static async changePriority(id: number, priority: Priority) {
    const { data } = await httpClient().patch(`/tag/${id}/priority`, {
      priority,
    });
    return data;
  }
}